<!-- PhoneWithExtensionInput.vue -->
<script lang="ts" setup>
import TextInput from "../TextInput.vue";
import PhoneInput from "./PhoneInput.vue";
import { IconTypes } from '../../Enums/UiEnums';
import { LimitToIntegerPositive } from "../../lib/Validation"
import { computed } from "vue";
import Icon from "../Icon.vue";

    const props = withDefaults(defineProps<{
        phone: string|undefined,
        extension: string|undefined,
        phoneDescription?: string,
        showPhoneDescription?: boolean,
        title?: string,
        disabled?: boolean
    }>(), {
        showPhoneDescription: true
    });

    const emits = defineEmits<{
        "update:phone": [val: string|undefined],
        "update:extension": [val: string|undefined]
        "update:phoneDescription": [val: string|undefined]
    }>();

    const extensionTitle = computed(() =>{
        if (props.title?.length)
            return `${props.title} (Extension)`;
        return "Extension";
    });

    const phoneDescriptionTitle = computed(() =>{
        if (props.title?.length)
            return `${props.title} (Description)`;
        return "Description";
    });
</script>

<template>
    <div class="row">
        <div class="col-auto pe-0" style="width: 15rem" >
            <PhoneInput 
                :modelValue="props.phone"
                @update:modelValue="val => emits('update:phone', val)"
                :title="props.title"
                :disabled="props.disabled" />
        </div>

        <div class="col-auto pe-0" style="width: 9rem">
            <TextInput 
                :maxLength="6" 
                :title="extensionTitle"
                :textValue="props.extension"
                @update:textValue="val => emits('update:extension', val)"
                :acceptCharacter="LimitToIntegerPositive">
                <template #LeftAddon>
                    <Icon :icon="IconTypes.XMark" />
                </template>
            </TextInput>
        </div>

        <div v-if="showPhoneDescription" class="col-auto pe-0" style="width: 9rem">
            <TextInput 
                :maxLength="6" 
                :title="phoneDescriptionTitle"
                :textValue="props.phoneDescription"
                @update:textValue="val => emits('update:phoneDescription', val)">
                <template #LeftAddon>
                    <Icon :icon="IconTypes.Comment" />
                </template>
            </TextInput>            
        </div>
    </div>
</template>